var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentMethod(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 35.997,
    viewBox: "0 0 36 35.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment-method",
    transform: "translate(0 -0.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184",
    transform: "translate(10.74 27.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M154.142,384.423a.734.734,0,0,0-.04-.132.713.713,0,0,0-.065-.121.683.683,0,0,0-.194-.194.693.693,0,0,0-.122-.065.659.659,0,0,0-.131-.04.693.693,0,0,0-.274,0,.68.68,0,0,0-.132.04.712.712,0,0,0-.121.065.7.7,0,0,0-.259.315.682.682,0,0,0-.04.132.676.676,0,0,0,0,.274.66.66,0,0,0,.04.131.65.65,0,0,0,.065.122.683.683,0,0,0,.194.194.708.708,0,0,0,.121.065.683.683,0,0,0,.132.04.677.677,0,0,0,.274,0,.662.662,0,0,0,.131-.04.693.693,0,0,0,.122-.065.683.683,0,0,0,.194-.194.694.694,0,0,0,.065-.122.71.71,0,0,0,.04-.131.675.675,0,0,0,0-.274Z",
    transform: "translate(-152.75 -383.857)",
    fill: "#3c4b61"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186",
    transform: "translate(0 21.813)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M32.343,315.9l-.009-.021c-.647-1.514-2.165-2.074-3.961-1.461l-4.9,1.355a3.211,3.211,0,0,0-1.989-1.958l-.019-.007-5.385-1.828a5.554,5.554,0,0,0-4.481-2.062,5.623,5.623,0,0,0-4.392,2.634H.7a.7.7,0,0,0-.7.7v8.865a.7.7,0,0,0,.7.7H4.884a.7.7,0,0,0,.7-.7v-.607H7.547a.7.7,0,0,0,.7-.7v-.2a4.985,4.985,0,0,1,2.568.922,42.548,42.548,0,0,0,4.224,2.157l.031.013a6.311,6.311,0,0,0,2.262.426,5.6,5.6,0,0,0,2.33-.5l10.827-3.877.057-.023A3,3,0,0,0,32.343,315.9ZM4.181,321.42H1.406v-7.459H4.181Zm2.664-1.31H5.587v-6.148H6.844Zm23.144-1.67-10.823,3.875-.032.012-.028.012a4.557,4.557,0,0,1-3.5.06,40.721,40.721,0,0,1-4.082-2.085A6.329,6.329,0,0,0,8.25,319.2v-5.663a4.342,4.342,0,0,1,3.352-2.211,4.057,4.057,0,0,1,3.442,1.617.7.7,0,0,0,.373.3l5.588,1.9A1.578,1.578,0,0,1,22.153,317a1.37,1.37,0,0,1-1.683.946l-6.3-2a.7.7,0,0,0-.425,1.341l6.31,2,.02.006a2.76,2.76,0,0,0,2.111-.245,2.758,2.758,0,0,0,1.319-1.666q.024-.085.043-.171l5.279-1.462c.762-.26,1.763-.354,2.209.672C31.5,317.629,30.3,318.292,29.988,318.44Z",
    transform: "translate(0 -309.922)",
    fill: "#3c4b61"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188",
    transform: "translate(23.854 8.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M340.643,124.064a.683.683,0,0,0-.041-.132.714.714,0,0,0-.152-.228.672.672,0,0,0-.107-.087.713.713,0,0,0-.121-.065.7.7,0,0,0-.406-.04.66.66,0,0,0-.131.04.694.694,0,0,0-.122.065.683.683,0,0,0-.194.194.712.712,0,0,0-.065.121.68.68,0,0,0-.04.132.675.675,0,0,0,0,.274.659.659,0,0,0,.04.131.693.693,0,0,0,.065.122.683.683,0,0,0,.194.194.693.693,0,0,0,.122.065.71.71,0,0,0,.131.04.693.693,0,0,0,.137.014.705.705,0,0,0,.138-.014.744.744,0,0,0,.131-.04.712.712,0,0,0,.121-.065.683.683,0,0,0,.194-.194.649.649,0,0,0,.065-.122.661.661,0,0,0,.041-.131.71.71,0,0,0,0-.274Z",
    transform: "translate(-339.25 -123.498)",
    fill: "#3c4b61"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190",
    transform: "translate(2.088 0.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M62.9,2.4H58.719a.7.7,0,0,0-.7.7v.607H56.056a.7.7,0,0,0-.7.7v.2A4.985,4.985,0,0,1,52.784,3.7,42.545,42.545,0,0,0,48.56,1.542l-.031-.013a5.982,5.982,0,0,0-4.591.072L41.108,2.614,38.724.229a.7.7,0,0,0-.994,0L29.9,8.059a.7.7,0,0,0,0,.994l13.38,13.38a.76.76,0,0,0,.994,0l7.148-7.148c.186.016.379.025.579.025a5.623,5.623,0,0,0,4.392-2.634H62.9a.7.7,0,0,0,.7-.7V3.108A.7.7,0,0,0,62.9,2.4ZM38.226,1.721l1.6,1.6a3.065,3.065,0,0,1-3.205,0Zm-5.233,8.438-1.6-1.6,1.6-1.6a3.066,3.066,0,0,1,0,3.205ZM43.776,20.941l-1.6-1.6a3.061,3.061,0,0,1,3.2,0Zm2.615-2.615a4.468,4.468,0,0,0-5.231,0l-7.154-7.154a4.468,4.468,0,0,0,0-5.231l1.6-1.6a4.468,4.468,0,0,0,5.231,0l1.521,1.521A2.787,2.787,0,0,0,40.27,7.39a4.007,4.007,0,1,0,4.608,4.961l2.374.806A4.489,4.489,0,0,0,48,16.72Zm-4.275-6.913.019.007,1.406.477A2.6,2.6,0,1,1,40.01,8.925,3.113,3.113,0,0,0,42.117,11.414Zm6.894,4.294a3.075,3.075,0,0,1-.449-1.462,5.467,5.467,0,0,0,1.24.671Zm6.342-4.015A4.342,4.342,0,0,1,52,13.9a5.118,5.118,0,0,1-.733-.052h0a4.027,4.027,0,0,1-2.6-1.425c-.014-.021-.075-.1-.085-.114a.7.7,0,0,0-.387-.322l-5.59-1.9a1.578,1.578,0,0,1-1.148-1.861h0v0a1.37,1.37,0,0,1,1.683-.943l6.3,2a.7.7,0,1,0,.425-1.341l-5.01-1.588L44.8,6.309h0L42.208,3.714l2.229-.8.024-.009.007,0,.028-.012a4.557,4.557,0,0,1,3.5-.06,40.729,40.729,0,0,1,4.083,2.085,6.328,6.328,0,0,0,3.271,1.113Zm2.664-.423H56.759V5.121h1.257Zm4.181,0H59.423V3.811H62.2Z",
    transform: "translate(-29.691 -0.023)",
    fill: "#3c4b61"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMethod);
export default __webpack_public_path__ + "static/media/payment-method.7862c5f578180c3771e705795b35eb59.svg";
export { ForwardRef as ReactComponent };